import { SelectPicker } from "rsuite";
import { useTranslation } from "react-i18next";
import "./OrderFilters.css";

const OrderServiceServedItems = ({
  onServiceItemChange,
  orderServiceItems = [],
  servedByList = [],
  setStopSubmit,
}: {
  onServiceItemChange?: Function;
  orderServiceItems?: any[];
  servedByList?: any[];
  setStopSubmit?: Function;
}) => {
  const { t } = useTranslation();

  const updateServedBy = (index: number, value: number) => {
    const updatedItems = orderServiceItems.map((item, i) =>
      i === index ? { ...item, item_served_by: value } : item,
    );
    onServiceItemChange?.(updatedItems);
  };

  return (
    <div>
      <div className="service-items-grid">
        {orderServiceItems?.map((sitem: any, index: number) => {
          const fieldSuffix = `${sitem.product_id}_${sitem.qty_no}_${index}`;

          return (
            <div className="service-item" key={fieldSuffix}>
              <label>
                {sitem.item_name} {sitem.qty_no}
              </label>

              <SelectPicker
                data={servedByList}
                valueKey="id"
                labelKey="name"
                value={sitem.item_served_by}
                onChange={(value) => updateServedBy(index, value)}
                cleanable
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderServiceServedItems;
